export enum SearchType {
    POINT_OF_INTEREST_BY_CITY = 'POINT_OF_INTEREST_BY_CITY',
    GEO = 'GEO',
    TEXT = 'TEXT',
    COUNTRY = 'COUNTRY',
    STATE = 'STATE',
    CITY = 'CITY',
}
